import { gql } from "@apollo/client";

export const lookupHealthProfessionQuery = gql`
  query healthProfessions {
    healthProfessions @rest (type: "healthProfessions" path: "/public/health-professions.json") {
      healthProfessions {
        professionCode
        professionName
      }
    }
  }
`;